import React, { useState } from 'react';
import logComponent from '../../common/logComponent';
import './TooltipMenu.css';

export default function TooltipMenu({ menuItems, isVisible }) {
  const [key, setKey] = useState('val');

  if (logComponent('TooltipMenu')) { console.debug('TooltipMenu rendered'); }

  return (
    <div className={'Tooltip-Menu' + (isVisible ? ' Tooltip-Menu--show' : '')} >
      <svg className="Tooltip-Menu__connector" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 13">
        <polygon points="0,12 12,0 24,12" />
        <polygon points="0,13 12,1 24,13" stroke="none" />
      </svg>

      <ul className="Tooltip-Menu__body">
        {
          menuItems.map(item =>
            <li
              key={item.text}
              className="Tooltip-Menu__item"
              onClick={item.onClick}>{item.text}</li>
          )
        }
      </ul>
    </div>
  );
}
